// import Sidebar from "./Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { FileText, Calendar, BookOpen, Image, Link as LinkIcon } from "lucide-react";
import { useState, useEffect } from "react";
import Sidebar from "../pages/Sidebar";

const DashboardLayout = () => {
  const [collapse, setCollapse] = useState(false);
  const location = useLocation();


  const menuItems = [
    { label: "News", path: "/dashboard/news", icon: FileText },
    { label: "Events", path: "/dashboard/events", icon: Calendar },
    { label: "Scheme", path: "/dashboard/scheme", icon: BookOpen },
    { label: "Programs", path: "/dashboard/programs", icon: BookOpen },
    { label: "Documents", path: "/dashboard/documents", icon: FileText },
    { label: "Photos", path: "/dashboard/photos", icon: Image },
    { label: "Notices", path: "/dashboard/notices", icon: FileText },
    { label: "Important Links", path: "/dashboard/important-links", icon: LinkIcon },
    { label: "Grievance", path: "/dashboard/grievance", icon: BookOpen },
  ];

  // Auto-collapse on News route
  useEffect(() => {
    if (location.pathname === "/dashboard/news") {
      setCollapse(true);
    } else {
      setCollapse(false);
    }
  }, [location]);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar
        menuItems={menuItems}
        collapse={collapse}
        setCollapse={setCollapse}
      />
      <main className="flex-1 p-6">
        <Outlet /> {/* Child routes render hotil */}
      </main>
    </div>
  );
}

export default DashboardLayout;